import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CATEGORIES = ["Inventory", "Orders", "Employees", "Customers", "Designs", "Pop-ups/Events", "Bills", "Personal", "Urgent"];
export const PRIORITIES = ["Low", "Normal", "High", "Urgent"];

export const CATEGORY_COLORS = {
  Inventory: "#E0F2FE", Orders: "#DCFCE7", Employees: "#FEF9C3", Customers: "#FCE7F3",
  Designs: "#F3E8FF", "Pop-ups/Events": "#FFEDD5", Bills: "#FEE2E2", Personal: "#F3F4F6", Urgent: "#FF3B30",
};
export const PRIORITY_COLORS = { Low: "#9CA3AF", Normal: "#3B82F6", High: "#F59E0B", Urgent: "#FF3B30" };

export function fileUrl(path) {
  const token = localStorage.getItem("token");
  return `${API}/files/${path}?auth=${token}`;
}

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => (e && e.msg) || JSON.stringify(e)).join(" ");
  if (detail && detail.msg) return detail.msg;
  return String(detail);
}
